import React, {
  createContext,
  ReactNode,
  useContext,
  useMemo,
  useState,
} from "react";
import { DRAWER_WIDTH, RESIZE_HANDLE_WIDTH } from "modules/utils/Constants";

interface IContextProps {
  isResizing: boolean;
  rightWidth: number;
  setIsResizing: (isResizing: boolean) => void;
  setRightWidth: (width: number) => void;
}

const PanelSizeContext = createContext<IContextProps>({
  isResizing: false,
  setIsResizing: () => {},
  rightWidth: DRAWER_WIDTH,
  setRightWidth: () => {},
});

export interface IProviderProps {
  children?: ReactNode;
}

export const PanelSizeProvider = ({ children }: IProviderProps) => {
  const [isResizing, setIsResizing] = useState(false);
  const [rightWidth, setRightWidth] = useState(DRAWER_WIDTH);

  const value = useMemo<IContextProps>(
    () => ({
      isResizing,
      setIsResizing,
      rightWidth: rightWidth + RESIZE_HANDLE_WIDTH,
      setRightWidth,
    }),
    [isResizing, rightWidth],
  );

  return (
    <PanelSizeContext.Provider value={value}>
      {children}
    </PanelSizeContext.Provider>
  );
};

export const usePanelSize = () => useContext(PanelSizeContext);
